import { useEffect, useRef, useState } from 'react';

const INTERACTION_EVENTS = ['touchstart', 'mousedown', 'keydown'];

/**
 * Tracks whether the kiosk has had no touch/mouse/keyboard interaction for
 * `timeoutMs`. Starts idle immediately when `enabled` — a freshly booted (or
 * just-returned-to) kiosk rests in attract mode until someone touches the
 * screen, then stays awake as long as interaction keeps arriving.
 */
export const useKioskIdle = (timeoutMs, enabled) => {
  const [isIdle, setIsIdle] = useState(enabled);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled) {
      setIsIdle(false);
      return undefined;
    }

    setIsIdle(true);

    const arm = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setIsIdle(true), timeoutMs);
    };

    const handleInteraction = (e) => {
      // Controls that work *inside* attract mode (the loop's video picker)
      // opt out so using them doesn't wake the kiosk and close the loop.
      if (e.target instanceof Element && e.target.closest('[data-kiosk-keep-idle]')) return;
      setIsIdle(false);
      arm();
    };

    INTERACTION_EVENTS.forEach((evt) =>
      window.addEventListener(evt, handleInteraction, { passive: true })
    );

    return () => {
      clearTimeout(timerRef.current);
      INTERACTION_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, handleInteraction)
      );
    };
  }, [enabled, timeoutMs]);

  return isIdle;
};

export default useKioskIdle;
